export function blobToFile(blob: Blob, fileName: string) {
  return new File([blob], fileName, {
    type: blob.type,
    lastModified: Date.now(),
  });
}

export const convertURLtoFile = async (url: string) => {
  const response = await fetch(url, {
    headers: {
      'Access-Control-Allow-Origin': '*',
    },
  });
  const data = await response.blob();
  const ext = url.split('.').pop(); // url 구조에 맞게 수정할 것
  const filename = url.split('/').pop(); // url 구조에 맞게 수정할 것
  const metadata = { type: `image/${ext}` };
  return new File([data], filename!, metadata);
};
